<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta v-if="msgAlerta" class="row-space" :mensagem="msgAlerta" />

    <div class="form-edit-page">
        <form @submit.prevent="submitForm">
            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 90px;">
                    <label class="label-caption">Código</label>
                    <div class="field-label field-label-end">{{ objEdicao.cdoperador }}</div>
                </div>                
                
                <div class="form-item flexible">
                    <label class="label-caption" for="nmoperador">Nome</label>
                    <input type="text" v-model="objEdicao.nmoperador" id="nmoperador" required maxlength="80" v-uppercase />
                </div>
                
                <div class="form-item" style="flex: 0 0 160px;">
                    <label class="label-caption" for="cpf">CPF</label>
                    <input type="text" class="input-center" v-model="objEdicao.cpf" id="cpf" maxlength="14" v-cpf />
                </div>

                <div class="form-item-char40">
                    <label class="label-caption" for="apelido">Apelido</label>
                    <input type="text" v-model="objEdicao.apelido_operador" id="apelido" maxlength="30" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Endereço</label>
                    <input type="text" v-model="objEdicao.endereco" maxlength="100" v-uppercase />
                </div>
                <div class="form-item-char10">
                    <label class="label-caption">Número</label>
                    <input type="text" class="input-right" v-model="edNmEndereco" v-number maxlength="5" />
                </div>
                <div class="form-item">
                    <label class="label-caption">Complemento</label>
                    <input type="text" v-model="objEdicao.complemento" maxlength="100" v-uppercase />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Bairro</label>
                    <input type="text" v-model="objEdicao.bairro" maxlength="100" v-uppercase />
                </div>
                
                <div class="form-item">
                    <label class="label-caption">Município</label>
                    <input type="text" v-model="objEdicao.nmmunicipio" maxlength="100" v-uppercase />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">UF</label>
                    <input type="text" v-model="objEdicao.uf" maxlength="2"  v-uppercase/>
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">CEP</label>
                    <input type="text" v-model="objEdicao.cep" v-cep maxlength="10" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item" style="flex: 0 0 160px;">
                    <label class="label-caption" for="fone">Telefone</label>
                    <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
                </div>

                <div class="form-item flexible">
                    <label class="label-caption" for="email">Email</label>
                    <input type="email" v-model="objEdicao.email" id="email" />
                </div>

                

                <div class="form-item-char20">
                    <label class="label-caption">CNH Número</label>
                    <input type="text" v-model="objEdicao.cnh_numero" maxlength="20" />
                </div>

                

                <div class="form-item-char15">
                    <label class="label-caption">CNH Categoria</label>
                    <input type="text" v-model="objEdicao.cnh_categoria" maxlength="2" v-uppercase />
                </div>

                

                <div class="form-item-char20">
                    <label class="label-caption">CNH Validade</label>
                    <input type="date" v-model="objEdicao.cnh_validade" maxlength="2" />
                </div>



                <div class="form-item-char20">
                    <label class="label-caption" for="fone">Login</label>
                    <input type="text" v-model="objEdicao.login" maxlength="20" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption" for="fone">Senha</label>
                    <input type="password" v-model="objEdicao.senha" maxlength="20" />
                </div>
            </div>


            <div v-if="props.cdPerfil==1" class="row row-space">
                <div class="form-item-char40">
                    <EquipamentoSetorSelect v-model:idSelecionado="objEdicao.idequipamentosetor" />
                </div>

                <EquipamentoSelect class="form-item flexible" :flagTipo="1" v-model:idSelecionado="objEdicao.idequipamento" />
            </div>


            <div v-if="props.cdPerfil==5" class="row row-space">
                <FornecedorSelect class="form-item flexible" :ckIpPrestador="true" :descCaption="'Prestador de Serviço'" v-model:fornecedorSelecionado="objEdicao.idipprestador" />
            </div>


            <div class="row-end">
                <label for="ckAtivo">Ativo</label>
                <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
            </div>
            
            <div class="row-end">
                <label for="ckChecklist">Habilitar Checklist</label>
                <input id="ckChecklist" type="checkbox" class="input-checkbox" v-model="ckChecklist" />
            </div>

            <div v-if="props.cdPerfil==1" class="row-end">
                <label for="ckAbreOs">Permite abertura de OS</label>
                <input type="checkbox" class="input-checkbox" id="ckAbreOs" v-model="ckAbreOs" />
            </div>

            <div v-if="props.cdPerfil==1" class="row-end">
                <label for="ckTrocaEquipamento">Permite troca de equipamento</label>
                <input type="checkbox" class="input-checkbox" id="ckTrocaEquipamento" v-model="ckTrocaEquipamento" />
            </div>

            <div class="row-end">
                <label for="ckTerceirizado">Terceirizado</label>
                <input type="checkbox" class="input-checkbox" id="ckTerceirizado" v-model="ckTerceirizado" />
            </div>


            <div class="row-end margin-top10">
                <button class="btn-confirm" type="submit">Salvar</button>
                <button class="btn-cancel" type="cancel" @click="cancelForm">Cancelar</button>
            </div>
        </form>

    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { criarOperador } from '@/models/Operador';
import { Funcoes } from '@/funcoes/utils';
import { genericPut, getCadastroById } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Validar  } from '@/funcoes/validacoes';
import EquipamentoSelect from '@/selects/EquipamentoSelect.vue';
import EquipamentoSetorSelect from '@/selects/EquipamentoSetorSelect.vue';
import FornecedorSelect from '@/selects/FornecedorSelect.vue';
import MensagemAlerta from '@/components/MensagemAlerta.vue';

const emit = defineEmits(['close', 'salvo']);
const props = defineProps({
    idEdicao: {type: Number, default: 0},
    cdPerfil: {type: Number, default: 1}});

const ckAbreOs = ref(false);
const ckAtivo = ref(false);
const ckChecklist = ref(false);
const ckTerceirizado = ref(false);
const ckTrocaEquipamento = ref(false);
const edNmEndereco = ref(null);
const msgAlerta = ref(null);
const objEdicao = criarOperador();
const isLoading = ref(false);

const submitForm = async () => {
    try {
        msgAlerta.value = validarDados();
        if (msgAlerta.value) return;

        isLoading.value=true;
        objEdicao.ativo = ckAtivo.value ? 'S' : 'N';
        objEdicao.blterceirizado = ckTerceirizado.value ? 'S' : 'N';
        objEdicao.bltroca_equipamento = ckTrocaEquipamento.value ? 'S' : 'N';
        objEdicao.cdperfil = props.cdPerfil;
        objEdicao.ckabreos = ckAbreOs.value ? 'S' : 'N';
        objEdicao.ckchecklist = ckChecklist.value ? 'S' : 'N';
        objEdicao.nmendereco = Funcoes.integerFromString(edNmEndereco.value);
        const response = await genericPut('/cad/operador', objEdicao);
        if (response.bolok === 1){
            emit('salvo');
            emit('close');
        }else{
            msgAlerta.value = `ATENÇÃO: ${response.erro}`
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
};

const cancelForm = () => {emit('close');};

const lerDados = async() => {
    try{
        isLoading.value=true;

        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('operador', props.idEdicao);
                Object.assign(objEdicao, req[0]);
            }catch (error){console.error('Erro leitura dos dados', error);}
        }else{
            objEdicao.idmunicipio   = globalStore.idmunicipio;
        }
        objEdicao.idlogin           = globalStore.idlogin;
        ckAbreOs.value              = objEdicao.ckabreos==='S';
        ckAtivo.value               = objEdicao.ativo==='S';
        ckChecklist.value           = objEdicao.ckchecklist==='S';
        ckTerceirizado.value        = objEdicao.blterceirizado==='S';
        ckTrocaEquipamento.value    = objEdicao.bltroca_equipamento==='S';
        edNmEndereco.value          = Funcoes.formatInteger(objEdicao.nmendereco);
    }finally{isLoading.value=false;}
}

function validarDados(){
    let r = Validar.cPF(objEdicao.cpf);
    if (!r.ok) return r.msg;
    return null;
}

onMounted(lerDados);
</script>